/*---------------------------
| Store
---------------------------*/
import { calcElementPropByScroll } from "./calcElementPropByScroll";

// Action Types
const actionPrefix = "SiteHeaderContext:";
export const actionTypes = {
    SET_HAS_MOUNTED: `${actionPrefix} Set Has Mounted`,
    RESET_STATE: `${actionPrefix} Reset State`,
    SET_HEADER: `${actionPrefix} Set Header`,
    SET_ANIMATION_SEQUENCE: `${actionPrefix} Set Animation Sequence`,
    SET_ANIMATION_IN: `${actionPrefix} Set Animation In`,
    SET_ANIMATION_OUT: `${actionPrefix} Set Animation Out`,
    SET_ANIMATION_OVERFLOW_IS_VISIBLE: `${actionPrefix} Set Animation Overflow isVisible`,
    SET_AUTH_MENU_HAS_THREE_COLUMNS: `${actionPrefix} Set Auth Menu Has Three Columns`,
    SET_MAREKTING_MESSAGE_HIDE_BELL: `${actionPrefix} Set Marketing Message Hide Bell`,
    SET_MAREKTING_MESSAGE_HTML: `${actionPrefix} Set Marketing Message HTML`,
    SET_HAMBURGER_MODAL_IS_OPEN: `${actionPrefix} Set Hamburger Modal Is Open`,
    SET_IS_COMPACT: `${actionPrefix} Set Bottom Row as Enabled`
};

// Reducer
export const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.SET_HAS_MOUNTED: {
            return {
                ...state,
                hasMounted: action.hasMounted
            };
        }
        case actionTypes.RESET_STATE: {
            return {
                ...state,
                ...action.stateProps
            };
        }
        case actionTypes.SET_HEADER: {
            const headerProps = calcElementPropByScroll({
                scrollY: action.scrollY,
                elementConfig: state.header.config
            });

            const header = {
                ...state.header,
                ...headerProps
            };

            return {
                ...state,
                header
            };
        }
        case actionTypes.SET_ANIMATION_SEQUENCE: {
            const {
                scrollY,
                animationSequenceRef,
                scrollDirectionRef
            } = action;

            const scrollDirection = scrollDirectionRef.current;
            const scrollYBreakpoint = state.animation.scrollYBreakpoint;
            let sequence = animationSequenceRef.current;

            // If it crosses threshold in either direction - invert
            // + 60 adds a cushion for animateOut trigger
            // - so if they are in between it is not jarring
            if (
                (scrollDirection === "down" && scrollY >= scrollYBreakpoint) ||
                (scrollDirection === "up" && scrollY < scrollYBreakpoint + 60)
            ) {
                sequence = scrollDirection === "down" ? "in" : "out";
            }

            // Update state only when crossing the scrollY breakpoint down and up thresholds
            if (sequence !== animationSequenceRef.current) {
                animationSequenceRef.current = sequence;
                const animation = {
                    ...state.animation,
                    sequence: sequence
                };

                return {
                    ...state,
                    animation
                };
            }
            // return unaltered state
            return { ...state };
        }
        case actionTypes.SET_ANIMATION_IN: {
            const animation = {
                ...state.animation,
                styleProps: state.animation.animateInProps
            };

            return {
                ...state,
                animation
            };
        }
        case actionTypes.SET_ANIMATION_OUT: {
            const animation = {
                ...state.animation,
                styleProps: state.animation.animateOutProps
            };

            return {
                ...state,
                animation
            };
        }
        case actionTypes.SET_ANIMATION_OVERFLOW_IS_VISIBLE: {
            const animation = {
                ...state.animation,
                overflow: {
                    ...state.animation.overflow,
                    isVisible: action.isVisible
                }
            };

            return {
                ...state,
                animation
            };
        }
        case actionTypes.SET_AUTH_MENU_HAS_THREE_COLUMNS: {
            return {
                ...state,
                authMenuHasThreeColumns: action.authMenuHasThreeColumns
            };
        }
        case actionTypes.SET_MAREKTING_MESSAGE_HIDE_BELL: {
            return {
                ...state,
                marketingMessage: {
                    ...state.marketingMessage,
                    hideBell: action.hideBell
                }
            };
        }
        case actionTypes.SET_MAREKTING_MESSAGE_HTML: {
            return {
                ...state,
                marketingMessage: {
                    ...state.marketingMessage,
                    html: action.html
                }
            };
        }
        case actionTypes.SET_HAMBURGER_MODAL_IS_OPEN: {
            return {
                ...state,
                hamburgerModalIsOpen: action.hamburgerModalIsOpen
            };
        }
        case actionTypes.SET_IS_COMPACT: {
            return {
                ...state,
                isCompact: action.isCompact
            };
        }
        default: {
            return { ...state };
        }
    }
};
